<div class="container tech-history-container">
  <div *ngIf="casesDataSource?.data?.length > 0; else emptyState">
    <!-- Mobile View -->
    <div fxHide.gt-sm="true" class="mobile-container">
      <app-history-card *ngFor="let case of pgList; let i = index" class="history-card">
        <card-line-1>
          <div>
            {{formatDate(case.CreatedDate)}}
          </div>
          <div>
            {{case.Status}}
          </div>
        </card-line-1>
        <card-line-2>
          <div class="card-column">
            <div *ngIf="case['Product_Category__c']">
              <adp-label labelKey="Account_TechSupport_History_ProductCategory"></adp-label>
            </div>
            <div>
              <adp-label labelKey="Account_TechSupport_History_Origin"></adp-label>
            </div>
            <div>
              <adp-label labelKey="Account_TechSupport_History_Transcipt"></adp-label>
            </div>
          </div>
          <div class="card-column card-column-right">
            <div *ngIf="case['Product_Category__c']">
              {{case.Product_Category__c}}
            </div>
            <div>
              {{case.Origin}}
            </div>
            <div>
              <span *ngIf="case.HasTranscript"><adp-label labelKey="Global_Yes"></adp-label> (<a
                  [routerLink]="['/account/tech-support-history/chat-transcript', case?.TranscriptId]"
                  [state]="{transcript: case?.Transcript}"><adp-label labelKey="Global_View"></adp-label></a>)</span>
              <span *ngIf="!case.HasTranscript"><adp-label labelKey="Global_No"></adp-label></span>
            </div>
          </div>
        </card-line-2>
      </app-history-card>

      <mat-paginator appStylePaginator [showTotalPages]="1" [length]="totalCount" [pageSize]="pageSize"
        hidePageSize="false" (page)="pageEvent = onPageChange($event)">
      </mat-paginator>
    </div>
    <!-- Desktop View -->
    <div fxHide fxShow.gt-sm="true">
      <table mat-table [dataSource]="casesDataSource" class="mat-elevation-z0">

        <ng-container matColumnDef="CreatedDate">
          <th mat-header-cell *matHeaderCellDef> <adp-label labelKey="Account_TechSupport_History_Date"></adp-label> </th>
          <td mat-cell *matCellDef="let element"> {{formatDate(element.CreatedDate)}}</td>
        </ng-container>

        <ng-container matColumnDef="Origin">
          <th mat-header-cell *matHeaderCellDef> <adp-label labelKey="Account_TechSupport_History_Origin"></adp-label> </th>
          <td mat-cell *matCellDef="let element"> {{element.Origin}}</td>
        </ng-container>

        <ng-container matColumnDef="Transcript">
          <th mat-header-cell *matHeaderCellDef> <adp-label labelKey="Account_TechSupport_History_Transcipt"></adp-label> </th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.HasTranscript"><adp-label labelKey="Global_Yes"></adp-label> (<a
                [routerLink]="['/account/tech-support-history/chat-transcript', element?.TranscriptId]"
                [state]="{transcript: element?.Transcript}"><adp-label labelKey="Global_View"></adp-label></a>)</span>
            <span *ngIf="!element.HasTranscript"><adp-label labelKey="Global_No"></adp-label></span>
          </td>
        </ng-container>

        <ng-container matColumnDef="ProductCategory">
          <th mat-header-cell *matHeaderCellDef> <adp-label labelKey="Account_TechSupport_History_ProductCategory"></adp-label> </th>
          <td mat-cell *matCellDef="let element"> {{element.Product_Category__c}}</td>
        </ng-container>

        <ng-container matColumnDef="Status">
          <th mat-header-cell *matHeaderCellDef> <adp-label labelKey="Account_TechSupport_History_Status"></adp-label> </th>
          <td mat-cell *matCellDef="let element"> {{element.Status}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator #desktopPaginator appStylePaginator [showTotalPages]="3" [length]="totalCount"
        [pageSize]="pageSize" hidePageSize="false">
      </mat-paginator>
    </div>

  </div>
  <ng-template #emptyState>
    <div *ngIf="isLoading" class="loading-state">
      <mat-spinner></mat-spinner>
    </div>
    <div *ngIf="!isLoading" class="empty-state">      
      <adp-label labelKey="Account_TechSupport_History_Empty"></adp-label>      
      <img src="../../../assets/images/dashboard-hero.svg" alt="" />
    </div>
  </ng-template>

</div>